/**
 * Money on screen. Tabular figures always, because a column of prices where the digits do not
 * line up cannot be scanned — and scanning a total is what a customer does over the counter.
 */

import { formatAmount, formatKes } from '@pos/shared';

import { cn } from './cn.js';

export type MoneyProps = {
  kes: number;
  /** `full` prints the currency; `bare` assumes a header already said Ksh. */
  form?: 'full' | 'bare';
  size?: 'sm' | 'base' | 'lg' | 'xl';
  className?: string;
};

const SIZES = {
  sm: 'text-sm',
  base: 'text-base',
  lg: 'text-lg font-semibold',
  xl: 'text-3xl font-bold tracking-tight',
} as const;

export function Money({ kes, form = 'full', size = 'base', className }: MoneyProps) {
  return (
    <span data-nums="money" className={cn(SIZES[size], className)}>
      {form === 'full' ? formatKes(kes) : formatAmount(kes)}
    </span>
  );
}

/** An IMEI, SKU or receipt number. Monospaced and slash-zeroed so it can be read aloud. */
export function Identifier({ value, className }: { value: string; className?: string }) {
  return (
    <span data-nums="id" className={cn('text-sm tracking-tight', className)}>
      {value}
    </span>
  );
}
